export var defaultSizeValue = 'small';